module.exports = __webpack_public_path__ + "img/non_owner_habitation.fab49441.png";